<section class="section-report">
  <h3>{{"dashboard:Report" | i18next}}</h3>
  <div class="section-content">
    <div class="report-expandable" [class.report-expanded]="isReportFullscreen" #reportExpandable>
      <div class="report-expandable-inner">
        <div class="report-expandable-header" [hidden]="!showReport">
          <span class="report-short-description">{{report?.shortDescription}}</span>
          <app-reports-date-picker [hidden]="!isReportFullscreen" [gridItem]="gridItem" (setPeriod)="setPeriod($event)" [showTitle]="false"
                                   [firstDate]="report?.firstDate" [dataAvailableFor]="report?.dataAvailableFor" [(data)]="rdp_data"></app-reports-date-picker>
          <div>
            <button *ngIf="isReportFullscreen" class="primary-button" mat-flat-button (click)="viewReport()">
              {{'dashboard:View Report' | i18next }}
            </button>
            <button mat-flat-button [ngClass]="['export-button', 'secondary-button']" (click)="exportReport()" [disabled]="!canExport">
              {{ 'dashboard:Add to Dashboard' | i18next }}
            </button>
            <button mat-flat-button [ngClass]="['download-button', 'secondary-button']" (click)="openDownloadDialog()">
              <i class="far fa-download"></i> Download Report
            </button>
            <button mat-flat-button [ngClass]="['download-button', 'secondary-button']" (click)="exportTable2()">
              <i class="far fa-download"></i> Download Report 2
            </button>
            <i class="fas" [class.fa-compress-alt]="isReportFullscreen" [class.fa-expand-alt]="!isReportFullscreen" (click)="toggleReportFullscreen()"></i>
          </div>
        </div>
        <div class="report-info">{{reportInfo}}</div>
        <app-rule-match [report]="report" [gridItem]="gridItem" [isReportModified]="isReportModified" [canExport]="canExport" [isStandAlone]="true"
                        [isInWizard]="false" [viewReportObservable$]="viewReportSubject$.asObservable()" [orderColumnsObservable$]="orderColumnsNotifier$.asObservable()"
                        [dataLoadingObservable$]="dataLoadingSubject$.asObservable()" [downloadDialogNotifier]="downloadDialogNotifier" [reportInfo]="reportInfo">
        </app-rule-match>
      </div>
    </div>
  </div>
</section>
